// extracted by mini-css-extract-plugin
module.exports = {"nav_box":"nav_box-jGaWQQkv","fix_nav_box":"fix_nav_box-3XfmvpLp","item_box":"item_box-1iK4VmJ7","current_box":"current_box-2JNoXLks"};